import React, { useEffect, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { get_cookies, timeZoneChanger,timeChanger,timeZoneChangerWithTime } from "../../../components/Cookies/Cookies";
import { format } from "date-fns";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		borderRadius:5,
		padding: theme.spacing(2, 4, 3),
		width: "500px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function DeleteSystemUser(props) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [item, setItem] = useState('');
	const [qty, setQty] = useState(1);
	const [selectedDate, setSelectedDate] = React.useState(format(new Date(), "yyyy-MM-dd"));
	const [selectedTime, setSelectedTime] = useState("");
	const [loading, setLoading] = useState(false);
	const handleOpen = () => {
		setOpen(true);
		setQty(1);
	};

	const handleClose = () => {
		setOpen(false);
		setQty(1);
	};
	const {user_id, user_fullname, showModal} = props;

		// useEffect(() => { //
		// 	const newDate = timeZoneChanger(selectedDate);
		// 	setSelectedDate(newDate);

		// }, []);

	const  deleteUserRole = async () => {
		setLoading(true);
		const formData = new FormData();
		formData.append("user_id", user_id);
		formData.append("username", get_cookies('username'));
		formData.append("branchidno", get_cookies('branchidno'));
		formData.append("trandate",timeZoneChangerWithTime(new Date()));
		await axios.post(process.env.REACT_APP_API_URL+'delete_system_user', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				showModal('Deleted System User '+ user_fullname, 'success');
				handleClose();
				// setLoading(false);
		  	}).catch(function (error) {
			
				showModal('Something went wrong '+ error.message, 'warning');
				handleClose();
				setLoading(false);
	  		});
	}

		const spinnerStyle = {
		border: "4px solid #f3f3f3",
		borderTop: "4px solid #3498db",
		borderRadius: "50%",
		width: "24px",
		height: "24px",
		animation: "spin 1s linear infinite",
		margin: "10px auto",
		};

		const spinKeyframes = `
		@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
		}
		`;
	
	const handleSubmit = (e) => {
		e.preventDefault();
		deleteUserRole();
    }

	return (
		<div>
			{/* <Button style={{minWidth: "190px"}} variant="outlined" color="primary" onClick={handleOpen}>
				Delete
			</Button> */}
			<Button variant="contained" onClick={handleOpen} style={{backgroundColor: "#E70000", color:"#fff"}}>
				Delete
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
				
						<style>{spinKeyframes}</style>
						{loading && <div style={spinnerStyle}></div>}
						{loading == false?<>						<h4 id="transition-modal-title">Delete User</h4>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={3}>
								<Grid item xs={9}>
								Are you sure you want to Delete this User? <br/><br/>
								{/* <h4>{user_fullname}</h4> */}
								</Grid>
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Cancel
								</Button>
								<Button type="submit" variant="contained"  style={{backgroundColor: "#E70000", color:"#fff"}}>
									Delete
								</Button>
							</div>
						</form></>:null}

					</div>
				</Fade>
			</Modal>
		</div>
	);
}
